export enum Environments {
  development = 'development',
  staging = 'staging',
  production = 'production',
}

interface EnvironmentHelperConstructor {
  environmentName: Environments;
}

const defaultOptions: EnvironmentHelperConstructor = {
  environmentName:
    Object.values(Environments).find(
      (environmentName) => environmentName === process.env.VITE_ENVIRONMENT_NAME
    ) ?? Environments.production
};

export const buildEnvironmentHelper = ({
  environmentName
}: EnvironmentHelperConstructor = defaultOptions) => {
  function notInProd(): boolean {
    return environmentName !== Environments.production;
  }

  function inDevOnly(): boolean {
    return environmentName === Environments.development;
  }

  return {
    notInProd,
    inDevOnly
  };
};

export default buildEnvironmentHelper();
